<app-navbar></app-navbar>

<div class="dashboard-full-width">
    <div class="">
        <div class="main-container-dashboard">

            <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->

            <div class="dashboard-container-right">
                <div class="main-container">
                    <div class="row">
                        <div class="card shadow m-5" style="width: 100%">
                            <div class="card-header header-dashboard-button-2">
                                <h4>Sample Centers</h4>
                                <button class="small-btn-dash" (click)="viewAddCenter(addCenterModal)"> Add Center 
                                    <i class="far fa-plus-square"></i></button>
                            </div>
                            <div class="card-body">


                                <div class="col-lg-12">

                                    <!-- <h3 class="dashboard-heading-1">Passenger personal Information</h3> -->
                                    <div class="">
                                        <div class=" table-responsive">
                                            <table
                                                class="table table-bordered table-condensed table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
                                                datatable [dtOptions]="dtOptions" width="100%">
                                                <thead class="">
                                                    <tr>
                                                        <th scope="col">S/N</th>
                                                        <th scope="col">Center Name</th>
                                                        <th scope="col">Location Address</th>
                                                        <th scope="col">Phone Number</th>
                                                        <th scope="col">Number of employees</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="dashboard-bg-white">
                                                    <tr>
                                                        <th scope="row">1</th>
                                                        <td>Waelchi Lod</td>
                                                        <td>London</td>
                                                        <td>098765432345</td>
                                                        <td>45</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">2</th>
                                                        <td>Waelchi, Hane and Schoen</td>
                                                        <td>USA</td>
                                                        <td>098765432345</td>
                                                        <td>90</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">3</th>
                                                        <td>Waelchi, Hane and Schoen</td>
                                                        <td>Nigeria</td>
                                                        <td>098765432345</td>
                                                        <td>10</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row">4</th>
                                                        <td>Waelchi, Hane and Schoen</td>
                                                        <td>Holland</td>
                                                        <td>098765432345</td>
                                                        <td>21</td>
                                                        <td><button class="btn-view">View</button></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
</div>





<ng-template #addCenterModal let-modal>

    <div class="card col-lg-12">
        <div class="row">
            <div class="card-header col-lg-12 header-dashboard-button-2">
                <h3>Add Sample Center</h3>
                <button class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
            </div>
            <div class="card-body p-4">
                <form [formGroup]="addCenterForm" (ngSubmit)="onSubmitCenter(addCenterForm.value)">
                    <div class="row">

                        <div class="col-md-4 mt-3">
                            <label class="form-label">Name of Center<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>

                            <input type="text" class="form-control" id="name" formControlName="name" placeholder=""
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.name.errors }">


                            <div *ngIf="submitted &amp;&amp; addCenterForm.controls.name.errors"
                                class="form-text text-danger">
                                <div *ngIf="addCenterForm.controls.name.errors.required">Center Name is required</div>
                                <div *ngIf="addCenterForm.controls.name.errors.maxlength">Center Name must be under 45
                                    characters</div>
                            </div>

                        </div>
                        <div class="col-md-4 mt-3">
                            <label class="form-label">Location Address<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>
                            <input type="text" class="form-control" formControlName="location" id="location"
                                aria-describedby="emailHelp"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.location.errors }"
                                placeholder="">
                            <div *ngIf="submitted &amp;&amp; addCenterForm.controls.location.errors"
                                class="form-text text-danger">
                                <div *ngIf="addCenterForm.controls.location.errors.required">Location is required</div>
                                <div *ngIf="addCenterForm.controls.location.errors.maxlength">Location must be under 45
                                    characters</div>
                            </div>
                        </div>
                        <div class="col-md-4 mt-3">
                            <label class="form-label">Phone Number<sup
                                    class="ml-1 font-weight-bolder text-danger">*</sup></label>
                            <input type="text" class="form-control" id="phone" maxlength="15" formControlName="phone"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; addCenterForm.controls.phone.errors }"
                                placeholder="">
                            <div *ngIf="submitted &amp;&amp; addCenterForm.controls.phone.errors"
                                class="form-text text-danger">
                                <div *ngIf="addCenterForm.controls.phone.errors.required">Phone Number is required</div>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-612 mt-3 mb-4 text-center mx-auto">
                        <button type="submit" class="btn btn-primary theme-btn"> Submit</button>
                    </div>

                </form>

            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark button-login" (click)="modal.close('Save click')">Ok</button>
    </div>

</ng-template>

<app-footer-dashboard></app-footer-dashboard>